import { Skeleton } from '@mui/material';

import { IProjectWithBlockchains } from 'domains/projects/types';
import { Placeholder } from 'modules/common/components/Placeholder';

import { ProjectsList } from '../ProjectsList';
import { useChanProjectsStyles } from './useChanProjectsStyles';

export interface ChainProjectsProps {
  chainProjects?: IProjectWithBlockchains[];
  isLoadingProjects: boolean;
}

export const ChainProjects = ({
  chainProjects = [],
  isLoadingProjects,
}: ChainProjectsProps) => {
  const { classes } = useChanProjectsStyles();

  return (
    <div className={classes.root}>
      <Placeholder
        hasPlaceholder={isLoadingProjects}
        placeholder={<Skeleton variant="text" width={145} height={30} />}
      >
        <ProjectsList projects={chainProjects} />
      </Placeholder>
    </div>
  );
};
